import { render, staticRenderFns } from "./VCadastroEmail.vue?vue&type=template&id=a89ca5d8&scoped=true&"
import script from "./VCadastroEmail.vue?vue&type=script&lang=js&"
export * from "./VCadastroEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a89ca5d8",
  null
  
)

export default component.exports